/**
 * Created by Sergii on 5/03/2017.
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Dropdown from '@common/containers/fields/Dropdown';

import '../styles/TestDetailsRow.scss';

export class TestDetailsRow extends Component {

    constructor(props) {
        super(props);
        this.td1Style = {paddingTop: '0px', paddingBottom: '0px'};
        this.td2Style = {padding: '0px'};
        this.inputStyle = {height: '23px', width: '100%', paddingLeft: '3px', border: '0px', border: '1px solid DimGray'};
    }

    getDropdownStyle = (marginLeft) => {
        return {
            container: (base) => ({
                ...base,
                height: '23px',
                border: '1px solid DimGray',
                backgroundColor: 'transparent'
            }),
            valueContainer: (base) => ({
                ...base,
                padding: '2px',
                top: '-4px'
            }),
            control: (base) => {
                return {
                    ...base,
                    height: '21px',
                    minHeight: '21px',
                    padding: '0',
                    backgroundColor: '#fff',
                    border: 'none',
                    borderColor: '#fff'
                }
            },
            indicatorSeparator: (base) => ({
                ...base,
                display: 'none'
            }),
            dropdownIndicator: (base) => ({
                ...base,
                padding: '8px 2px',
                marginTop: '-6px',
                marginRight: '1px'
            }),
            option: (base, state) => {
                let bc = '#fff';
                if (state.isFocused || state.isSelected) {
                    bc = '#eeeeee'
                }
                return {
                    ...base,
                    color: '#333',
                    height: '24px',
                    minHeight: '24px',
                    backgroundColor: bc,
                    padding: '3px 10px'
                }
            },
            menu: (base) => ({
                ...base,
                width: '150px',
                minWidth: '150px',
                marginLeft: marginLeft + 'px'
            })

        }
    }

    checkGene = (checked) => {
        this.props.checkGene(this.props.gene.id, checked);
    }

    updateGenesTableRow = (id, value) => {
        this.props.updateGenesTableRow(this.props.gene.id, id, value)
    }

    handleVariantChange = (e) => {
        this.updateGenesTableRow('variant', e.target.value);
    }

    handleCbChange = (e) => {
        this.checkGene(e.target.checked);
    }

    handleGeneDDChange = (e) => {
        this.updateGenesTableRow("gene", e)
    }

    handleClassificationDDChange = (e) => {
        this.updateGenesTableRow("classification", e)
    }

    handlePriorClassificationDDChange = (e) => {
        this.updateGenesTableRow("priorClassification", e)
    }

    render () {
        const { allGenes, classifications, style, gene, parent } = this.props;

        return (
            <tr 
                className={`Genes-table__body__row ${gene.checked ? 'genes-table-selected-row' : ''}`}
                style={style}
            >
                <td style={this.td1Style} className="Genes-table__body__cell Genes-table__cell-select">
                    <input
                        id={"cbx_test" + gene.id}
                        type="checkbox"
                        checked={gene.checked || false}
                        onChange={this.handleCbChange} />
                </td>
                <td className="genes-table-dd Genes-table__body__cell Genes-table__cell-gene" style={this.td2Style}>
                    <Dropdown
                        id={"gene_" + gene.id}
                        styles={this.getDropdownStyle()}
                        selectedValue={gene.gene}
                        searchable={true}
                        options={allGenes}
                        onValueChanged={this.handleGeneDDChange}
                        dropupAuto={false}
                        isDropup={false}
                        parent={parent}
                        optionsHeight={190}>
                    </Dropdown>
                </td>
                <td className="genes-table-dd Genes-table__body__cell Genes-table__cell-variant" style={this.td2Style}>
                    <input style={this.inputStyle}
                           id={"variant" + gene.id}
                           type="text"
                           value={gene.variant || ""}
                           onChange={this.handleVariantChange}
                    ></input>
                </td>
                <td className="genes-table-dd Genes-table__body__cell Genes-table__cell-classification" style={this.td2Style}>
                    <Dropdown
                        searchable
                        id={"classification_" + gene.id}
                        styles={this.getDropdownStyle()}
                        selectedValue={gene.classification}
                        options={classifications}
                        onValueChanged={this.handleClassificationDDChange}
                        dropupAuto={false}
                        isDropup={false}
                        parent={parent}
                        optionsHeight={190}>
                    </Dropdown>
                </td>
                <td className="genes-table-dd Genes-table__body__cell Genes-table__cell-prior-classification" style={this.td2Style}>
                    <Dropdown
                        searchable
                        id={"priorClassification_" + gene.id}
                        styles={this.getDropdownStyle(-20)}
                        selectedValue={gene.priorClassification}
                        options={classifications}
                        onValueChanged={this.handlePriorClassificationDDChange}
                        dropupAuto={false}
                        isDropup={false}
                        parent={parent}
                        optionsHeight={190}>
                    </Dropdown>
                </td>
            </tr>
        )
    }
}

TestDetailsRow.propTypes = {
    gene: PropTypes.object.isRequired
};